import Vue from 'vue';
import VueI18n from 'vue-i18n';

import ar from "./languages/values-ar.json";// 阿拉伯语
import sr from "./languages/values-b+sr+Latn.json";// 塞尔维亚语（拉丁字母）
import bn from "./languages/values-bn-rBD.json";// 孟加拉语
import es from "./languages/values-es-rES.json";// 西班牙语
import fr from "./languages/values-fr.json";// 法语
import hi from "./languages/values-hi.json";// 印地语
import ig from "./languages/values-ig-rNG.json";// 尼日利亚伊博语（Igbo）
import id from "./languages/values-in.json";// 印度尼西亚语
import mn from "./languages/values-mn-rMN.json";// 蒙古语
import ms from "./languages/values-ms-rMY.json";//马来语
import pt from "./languages/values-pt-rPT.json";// 葡萄牙语
import ru from "./languages/values-ru.json";// 俄语
import sw from "./languages/values-sw.json";// 斯瓦希里语
import tg from "./languages/values-tg-rTJ.json";// 塔吉克
import th from "./languages/values-th-rTH.json";//泰语
import tk from "./languages/values-tk.json";// 土库曼语
import tl from "./languages/values-tl.json";// 塔加洛语
import tr from "./languages/values-tr.json";//土耳其语
import ur from "./languages/values-ur-rPK.json";//乌尔都语
import yo from "./languages/values-yo-rNG.json";//约鲁巴语
import en from './languages/values.json'//英语

Vue.use(VueI18n);

function setlang(lang){
  if(!lang){
    // 默认系统语言
    lang =  (navigator.languages && navigator.languages[0]) || navigator.language;
  }
  // 反向语言
  // const rtlList = ['ar', 'ur']
  const coulanList = [
    'ar','sr','bn','es','fr','hi','ig','id','mn','ms','pt',
    'ru','sw','tg','th','tk','tl','tr','ur','yo','en',
  ]
  let langUse;
  // 设置语言
  if (coulanList.indexOf(lang.split("-")[0].toLowerCase()) > -1) {
    langUse = lang.split("-")[0].toLowerCase();
  } else {
    langUse = "en";
  }
  //语言正反向
  // if (rtlList.indexOf(lang.split("-")[0].toLowerCase()) > -1) {
  //   document.body.style.direction = "rtl";
  // } else {
  //   document.body.style.direction = "ltr";
  // }
  return langUse;
}
export {setlang};

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: setlang(), // 设置默认语言
  fallbackLocale: 'en', // 当找不到语言时的回退语言
  messages:{
    ar,sr,bn,es,fr,hi,ig,id,mn,ms,pt,
    ru,sw,tg,th,tk,tl,tr,ur,yo,en
  }// 语言包
});

export default i18n;
